export { default } from './SvgIcon';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/SvgIcon/index.js
// module id = 130
// module chunks = 2